<template>
	<div class="wd-dialog-wrapper" v-show="value" @click="onMaskClose">
		<div class="wd-dialog">
			<div class="wd-dialog__body" ref="copyContent">
<!--					<div class="item-title">-->
<!--						<slot name="title"></slot>-->
<!--						<div class="placeholder">&nbsp;</div>-->
<!--					</div>-->
<!--					<div class="item-list">-->
<!--						<slot name="list"></slot>-->
<!--					</div>-->
				<slot name="mainContent"></slot>
				<slot name="content"></slot>
			</div>
			<div class="wd-dialog__footer" ref="copyButton">
				<button class="wd-button wd-button-copy" @click="onCopyClick">复制到剪贴板</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		value: Boolean
	},
	methods: {
		getCopyText () {
			return this.$refs.copyContent.innerText
		},
		onCopyClick () {
			this.$copyText(this.$refs.copyContent.innerText).then(() => {
				this.$emit('input', false)
				this.$fxToast.success('已复制到剪贴板')
			})
		},
		onMaskClose (e) {
			if (!this.$refs.copyButton.contains(e.target)) {
				this.$emit('input', false)
			}
		}
	}
}
</script>

<style scoped>
.wd-dialog-wrapper{
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	background-color: rgba(0, 0, 0, .5);
	z-index: 50;
	display: flex;
	justify-content: center;
	align-items: center;
}
.wd-dialog{
	width: 90%;
	min-height: 240px;
	max-height: 50%;
	background-color: #fff;
	box-shadow: 0 5px 10px rgb(0 0 0 / 10%);
	border-radius: 5px;
	display: flex;
	flex-direction: column;
}
.wd-dialog__body{
	flex: 1;
	padding: 10px 15px;
	overflow: auto;
}
.wd-dialog__body p{
	margin: 0;
}
.wd-dialog__footer{
	width: 100%;
	display: flex;
	flex-direction: row;
}
.wd-button{
	width: 100%;
	display: inline-block;
	position: relative;
	padding: 0;
	height: 11.733vw;
	line-height: 11.2vw;
	font-size: 4.267vw;
	border-radius: 0.533vw;
	text-align: center;
	box-sizing: border-box;
}
.wd-button-copy{
	color: #fff;
	border: 1px solid #6495ed;
	background-color: #6495ed;
	border-radius: 0 0 5px 5px;
}
.item-title{
	font-size: .9em;
	color: #656565;
}
.item-title .title-name{
	font-size: 1em;
	font-weight: 500;
	color: #000;
}
.item-title .text-word{
	margin-top: 5px;
	font-size: .9em;
}
.order-item-block +
.order-item-block {
	margin-top: 8px;
}
.item-row{
	margin-top: 5px;
	font-size: .9em;
	color: #656565;
}
.item-remark{
	margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// Fx-share.vue?60ee0e2b